<template>
  <div class="c-container">
    <div class="u-container">
      <div class="c-container__inner">
        <h1 class="c-container__title">
          404 Not Found
        </h1>
        <div class="c-content-component">
          <p>The page you were looking for does not appear to exist.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pymChild from '../embed/index';

export default {
  mounted: () => {
    pymChild.sendHeight();
  },
  updated: () => {
    pymChild.sendHeight();
  },
};
</script>
